<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style scoped>
#app {
  height: 100%;
  text-align: center;
  color: #2c3e50;
}
</style>

<script>
export default {
  name: "App",
  mounted() {
    //解决a标签在ie下不跳转
    if (this.checkIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
    //以下是调用上面的函数
    // debugger
    // let browser = this.myBrowser()
    // alert(browser,'browser')
    // if ((browser === "IE55") || (browser === "IE6") || (browser === "IE7") || (browser === "IE8")){
    //   alert('建议浏览器：ie9+、火狐、谷歌')
    // }
    // if (myBrowser() == "IE8") {
    //     alert("我是 IE8");
    // }
  },
  methods: {
    checkIE() {
      return (
        "-ms-scroll-limit" in document.documentElement.style &&
        "-ms-ime-align" in document.documentElement.style
      );
    },
    myBrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
      var isIE =
        userAgent.indexOf("compatible") > -1 &&
        userAgent.indexOf("MSIE") > -1 &&
        !isOpera; //判断是否IE浏览器
      var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
      var isSafari = userAgent.indexOf("Safari") > -1; //判断是否Safari浏览器
      if (isIE) {
        var IE5 = (IE55 = IE6 = IE7 = IE8 = false);
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        IE55 = fIEVersion == 5.5;
        IE6 = fIEVersion == 6.0;
        IE7 = fIEVersion == 7.0;
        IE8 = fIEVersion == 8.0;
        if (IE55) {
          return "IE55";
        }
        if (IE6) {
          return "IE6";
        }
        if (IE7) {
          return "IE7";
        }
        if (IE8) {
          return "IE8";
        }
      } //isIE end
      if (isFF) {
        return "FF";
      }
      if (isOpera) {
        return "Opera";
      }
    }
  }
};
</script>
